module.exports = __webpack_public_path__ + "static/media/heart-icon.a54a3745.svg";